import React from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";

// Wrappers
import AuthRoutes from "./AuthRoutes";
import PrivateRoutes from "./PrivateRoutes";
import PublicRoutes from "./PublicRoutes";

// Pages
import Home from "../pages/App/Home";
import Login from "../pages/Auth/Login";
import Signup from "../pages/Auth/Signup";
import ProfileSetting from "../pages/App/ProfileSetting";
import Notification from "../pages/App/Notification";

const Routers = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public */}
        <Route element={<PublicRoutes />}></Route>
        {/* Private */}
        <Route element={<PrivateRoutes />}>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<Home />} />
          <Route path="/profile-setting" element={<ProfileSetting />} />
          <Route path="/notification" element={<Notification />} />

          
        </Route>
        {/* Auth */}
        <Route element={<AuthRoutes />}>
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Login />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Routers;
